export default __webpack_public_path__ + "static/media/T3_360_mobile.2bf33e18.jpg";